import { Box, BoxProps, createStyles } from '@mantine/core'

export type ShapeTypeProps = {
  color: string
} & BoxProps

const useStyles = createStyles((_theme, { color }: { color: string }) => {
  return {
    root: {
      borderRadius: '50%',
      background: color,
    },
  }
})

const Circle = ({ color, ...boxProps }: ShapeTypeProps) => {
  const { classes, cx } = useStyles({ color })
  return (
    <Box
      className={cx(classes.root)}
      sx={{
        borderRadius: '50%',
        background: color,
      }}
      {...boxProps}
    />
  )
}
export { Circle }
